module.exports = __webpack_public_path__ + "static/gallery-img-7-8c09a63649e11a6adeeecf2afb6b84ee.jpg";